import { AgnosticShipmentSort } from '../domain/AgnosticShipmentSort'

export function formatSort(sort: AgnosticShipmentSort): string {
  switch (sort) {
    case AgnosticShipmentSort.Status:
      return 'Status'
    case AgnosticShipmentSort.PickupAsc:
      return 'Pickup asc.'
    case AgnosticShipmentSort.PickupDesc:
      return 'Pickup desc.'
  }
}
